import { http } from '../../../../api/http';
import type { DashboardPlanillaData, DashboardKPIs, TendenciaMensual, DistribucionConcepto, DistribucionArea } from '../types/dashboard';

const ENDPOINT = '/planilla/dashboard';

export class DashboardService {
  static async getDashboard(anio?: number): Promise<DashboardPlanillaData> {
    const response = await http.get(ENDPOINT, { params: { anio } });
    return response.data;
  }

  static async getKPIs(idPeriodo?: number): Promise<DashboardKPIs> {
    const response = await http.get(`${ENDPOINT}/kpis`, { params: { idPeriodo } });
    return response.data;
  }

  static async getTendencia(anio: number): Promise<TendenciaMensual[]> {
    const response = await http.get(`${ENDPOINT}/tendencia/${anio}`);
    return response.data;
  }

  static async getDistribucionConceptos(idPlanilla: number): Promise<DistribucionConcepto[]> {
    const response = await http.get(`${ENDPOINT}/conceptos/${idPlanilla}`);
    return response.data;
  }

  static async getDistribucionAreas(): Promise<DistribucionArea[]> {
    const response = await http.get(`${ENDPOINT}/areas`);
    return response.data;
  }
}
